module.exports = __webpack_public_path__ + "static/img/2.ddd52e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/screenshot/2.png
// module id = 0wGf
// module chunks = 0